import {
  Divider,
  HStack,
  Label,
  SectionCard,
  SectionCardContent,
  SectionCardHeader,
  VStack,
} from '@eluve/components';
import {
  useAppointmentId,
  useTenantId,
} from '@eluve/frontend-appointment-hooks';
import { StartVirtualIntake } from '@eluve/frontend-feature-avatar';
import { OpenInAdminButton, OpenInReviewButton } from '@eluve/smart-blocks';

import { UploadAudioFileButton } from '../UploadAudioFileButton';

import { AddToTranscript } from './AddToTranscript';
import { ChangeAppointmentOwner } from './ChangeAppointmentOwner';
import { LatestAppointmentTemplate } from './LatestAppointmentTemplate';
import { LatestTranscriptMetadata } from './LatestTranscriptMetadata';
import { RegenerateSummary } from './RegenerateSummary';

interface EluveAdminPanelProps {
  readonlyMode?: boolean;
}
export const EluveAdminPanel: React.FC<EluveAdminPanelProps> = ({
  readonlyMode = false,
}) => {
  const appointmentId = useAppointmentId();
  const tenantId = useTenantId();

  return (
    <SectionCard>
      <SectionCardHeader>Eluve Admin Panel</SectionCardHeader>
      <SectionCardContent>
        {readonlyMode ? (
          <HStack wFull align="start" gap={6}>
            <VStack align="stretch" className="flex-1">
              <LatestAppointmentTemplate appointmentId={appointmentId} />
              <LatestTranscriptMetadata
                appointmentId={appointmentId}
                tenantId={tenantId}
              />
            </VStack>
            <VStack align="stretch" className="flex-1">
              <OpenInAdminButton
                appointmentId={appointmentId}
                tenantId={tenantId}
              />
              <OpenInReviewButton
                appointmentId={appointmentId}
                tenantId={tenantId}
              />
            </VStack>
          </HStack>
        ) : (
          <HStack wFull align="start" gap={6}>
            <VStack align="stretch" className="flex-1">
              <AddToTranscript appointmentId={appointmentId} />
              <Divider />
              <VStack>
                <Label className="px-1">Upload Audio File</Label>
                <UploadAudioFileButton appointmentId={appointmentId} />
              </VStack>
              <Divider />
              <LatestAppointmentTemplate appointmentId={appointmentId} />
              <LatestTranscriptMetadata
                appointmentId={appointmentId}
                tenantId={tenantId}
              />
            </VStack>
            <VStack align="stretch" className="flex-1">
              <Label>Change Owner</Label>
              <ChangeAppointmentOwner
                appointmentId={appointmentId}
                tenantId={tenantId}
              />
              <Divider />
              <Label>Misc. Actions</Label>
              <OpenInAdminButton
                appointmentId={appointmentId}
                tenantId={tenantId}
              />
              <OpenInReviewButton
                appointmentId={appointmentId}
                tenantId={tenantId}
              />
              <RegenerateSummary
                appointmentId={appointmentId}
                tenantId={tenantId}
              />
              <StartVirtualIntake
                appointmentId={appointmentId}
                tenantId={tenantId}
              />
            </VStack>
          </HStack>
        )}
      </SectionCardContent>
    </SectionCard>
  );
};
